import { exactNumber, decimal, parseAuthoringJSON } from "./authoring-json.mjs";

export const hasFlatTestForm = (document) => document.inputSchema?.type === "object" && Object.values(document.inputSchema.properties || {}).every((field) => ["string", "number", "integer", "boolean"].includes(field.type));

export function testInput(document, values, jsonText) {
  if (!hasFlatTestForm(document)) return parseAuthoringJSON(jsonText);
  const entries = [];
  for (const [name, field] of Object.entries(document.inputSchema.properties)) {
    const value = Object.hasOwn(values, name) ? values[name] : undefined;
    if (value == null || value === "" && (field.type !== "string" || field.enum || !document.inputSchema.required?.includes(name))) continue;
    let typed = value;
    if (field.enum) {
      const index = Number(value);
      if (!Number.isInteger(index) || index < 0 || index >= field.enum.length) throw new Error(`Выберите значение: ${name}`);
      typed = field.enum[index];
    } else if (field.type === "boolean") {
      if (value !== "true" && value !== "false") throw new Error(`Выберите да или нет: ${name}`);
      typed = value === "true";
    } else if (field.type === "number" || field.type === "integer") {
      typed = exactNumber(value);
      if (field.type === "integer" && decimal(value).includes("e-")) throw new Error(`Нужно целое число: ${name}`);
    }
    entries.push([name, typed]);
  }
  return Object.fromEntries(entries);
}
